/** Trigger outputs carrying the **new** status label — blocks `45` and `48`. */
export const NEW_STATUS_OUTPUTS = ['actualStatusValue', 'columnValue'];
/** Trigger outputs carrying the **previous** status label — block `48`. */
export const PREV_STATUS_OUTPUTS = ['prevStatusValue', 'previousColumnValue'];
/**
 * The trigger's output under the first of `fields` any node carries, as a label index, or
 * `null` for an empty cell and for a value that is not a label index at all (trigger `54`
 * exports the raw cell object). `null` fails every comparison but `$any$`, which is the
 * conservative reading: a condition that cannot read its value does not pass.
 */
export function triggerNumberOutput(context, fields) {
    for (const field of fields) {
        for (const outputs of Object.values(context.nodeResults)) {
            if (!(field in outputs))
                continue;
            const value = outputs[field];
            if (typeof value === 'number' && Number.isFinite(value))
                return value;
            if (value === null)
                return null;
        }
    }
    return null;
}
//# sourceMappingURL=node-results.js.map